import {EnvTypes, withSystem} from '@packages/systems/wfdl';
import {functionOf, TText} from '@packages/systems/wfdl-ast';
import {TOption} from '@packages/systems/plugins/Option';
import {TColor} from '@packages/systems/plugins/Color';
import {type DynamoEnvValueType} from '../types';

export const dynamoColorToText: EnvTypes.TypedValue = {
  envType: {
    dataType: functionOf(
      withSystem({isBindable: true}, TOption(TColor)),
      TText
    ),
    exported: 'hidden',
    implicit: 'prefilledArgs',
  },
  value: (option: DynamoEnvValueType<unknown>): string => {
    if (option === null || option.tag === 'None') return '';
    return typeof option.val === 'string' ? option.val : '';
  },
};
